// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../redux/slices/authSlice";
// import axios from "axios";
// import "../assets/Login.css";
// import { parse } from "tldts";

// const LoginPage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { loading, error, user } = useSelector((state) => state.auth);

//   const [userId, setUserId] = useState("");
//   const [password, setPassword] = useState("");
//   const [company, setCompany] = useState({
//     name: "",
//     logo: null,
//     favicon: null,
//     domain: "",
//     subdomain: "",
//   });

//   const [fetchError, setFetchError] = useState("");

//   const getDomainInfo = () => {
//     const hostname = window.location.hostname;
//     const parsed = parse(hostname);
//     const domain = parsed.domainWithoutSuffix || "";
//     const subdomain = parsed.subdomain || "";
//     return { domain, subdomain };
//   };

//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const { domain } = getDomainInfo();
//         const response = await axios.get("https://payyug.in/api/get-company", {
//           params: { domain },
//         });
//         const data = response.data;

//         if (data && Object.keys(data).length > 0) {
//           setCompany({
//             name: data.name || "",
//             logo: data.logo || null,
//             favicon: data.favicon || null,
//             domain: data.domain || "",
//             subdomain: data.subdomain || "",
//           });

//           if (data.favicon) {
//             const link =
//               document.querySelector("link[rel*='icon']") ||
//               document.createElement("link");
//             link.type = "image/png";
//             link.rel = "icon";
//             link.href = `${getImageUrl(data.favicon)}`;
//             document.head.appendChild(link);
//           }
//         } else {
//           setFetchError("Company info not found.");
//         }
//       } catch (err) {
//         console.error(err);
//         setFetchError("");
//       }
//     };

//     fetchCompany();
//   }, []);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(loginUser({ userId, password }));
//   };

//   useEffect(() => {
//     if (user) {
//       localStorage.removeItem("superPinVerified");
//       navigate("/dashboard");
//     }
//   }, [user, navigate]);

//   return (
//     <div className="admin-login-wrapper">
//       {/* === Animated Gradient Background Layers === */}
//       <div className="bg"></div>
//       <div className="bg bg2"></div>
//       <div className="bg bg3"></div>

//       {/* 🔹 Login Card */}
//       <div className="admin-login-card">
//         {/* === Image on Left === */}
//         <div className="admin-login-left">
//           <img
//             src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
//             alt="Work team"
//             className="admin-login-image"
//           />
//         </div>

//         {/* === Form on Right === */}
//         <div className="admin-login-right">
//           <div className="admin-login-logo-container">

//             {company.logo ? (
//               <img
//                 src={getImageUrl(company.logo)}
//                 alt="Company Logo"
//                 className="admin-login-logo"
//               />
//             ) : (
//               <div className="admin-login-logo-fallback">Logo</div>

//             )}
//           </div>

//           <h2 className="admin-login-title">
//             {company.name || "Create an account"}
//           </h2>

//           {/* === admin logo with title === */}

//           <p className="admin-login-subtitle"><p>👨‍💻</p> Admin Login</p>

//           {fetchError && (
//             <div className="admin-login-error-text">{fetchError}</div>
//           )}
//           {error && <div className="admin-login-error">{error}</div>}

//           <form onSubmit={handleSubmit} className="admin-login-form">
//             <div className="admin-login-input-group">
//               <input
//                 id="userId"
//                 value={userId}
//                 onChange={(e) => setUserId(e.target.value)}
//                 placeholder=" Enter Your User ID"
//                 type="text"
//                 className="admin-login-input-tech"
//                 required
//               />
//             </div>

//             <div className="admin-login-input-group">
//               <input
//                 id="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="Password"
//                 type="password"
//                 className="admin-login-input-tech"
//                 required
//               />
//             </div>

//             <button
//               type="submit"
//               className="admin-login-submit"
//               disabled={loading}
//             >
//               {loading ? "🔒 Signing In..." : "Submit"}
//             </button>
//           </form>

//           <p className="admin-login-terms">Terms & Conditions applied</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// const getImageUrl = (path) => {
//   if (!path) return "";
//   const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
//   return `https://payyug.in/${cleanPath}`;
// };



import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../redux/slices/authSlice";
import axios from "axios";
import "../assets/Login.css";
import { parse } from "tldts";
import { Eye, EyeOffIcon, Lock, Mail } from "lucide-react";
import { toast } from "react-toastify";
import { ArrowLeftRight } from "lucide-react";

/* ================= UTIL ================= */
const getImageUrl = (path) => {
  if (!path) return "";
  const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
  return `https://payyug.in/${cleanPath}`;
};

/* ================= COMPONENT ================= */
const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector((state) => state.auth);

  /* ================= STATE ================= */
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [frontLoading, setFrontLoading] = useState(false);
  const [frontError, setFrontError] = useState("");
  const [isSwapped, setIsSwapped] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [fetchError, setFetchError] = useState("");

  const [company, setCompany] = useState({
    name: "",
    logo: null,
    favicon: null,
    domain: "",
    subdomain: "",
  });

  /* ================= DOMAIN ================= */
  const getDomainInfo = () => {
    const parsed = parse(window.location.hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  /* ================= FETCH COMPANY ================= */
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();

        const res = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });

        const data = res.data;

        if (data && Object.keys(data).length > 0) {
          setCompany({
            name: data.name || "",
            logo: data.logo || null,
            favicon: data.favicon || null,
            domain: data.domain || "",
            subdomain: data.subdomain || "",
          });

          // 🔥 Dynamic favicon
          if (data.favicon) {
            const link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");

            link.type = "image/png";
            link.rel = "icon";
            link.href = getImageUrl(data.favicon);

            document.head.appendChild(link);
          }
        } else {
          setFetchError("Company info not found.");
        }
      } catch (err) {
        console.error(err);
        setFetchError("Unable to load company info.");
      }
    };

    fetchCompany();
  }, []);

  /* ================= LOGIN ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId || !password) {
      toast.warn("Please enter both Email and Password.");
      setFrontError("Please enter both Email and Password.");
      return;
    }

    setFrontLoading(true);
    setFrontError("");

    const MIN_LOADING_TIME = 2500;
    const startTime = Date.now();

    try {
      await dispatch(loginUser({ userId, password })).unwrap();

      const remaining = MIN_LOADING_TIME - (Date.now() - startTime);
      if (remaining > 0) {
        await new Promise((res) => setTimeout(res, remaining));
      }

      navigate("/dashboard");
    } catch (err) {
      setFrontError("Login failed. Check your credentials.");

      const remaining = MIN_LOADING_TIME - (Date.now() - startTime);
      if (remaining > 0) {
        await new Promise((res) => setTimeout(res, remaining));
      }
    } finally {
      setFrontLoading(false);
    }
  };

  /* ================= REDIRECT ================= */
  useEffect(() => {
    if (user) {
      localStorage.removeItem("superPinVerified");
      navigate("/dashboard");
    }
  }, [user, navigate]);

  /* ================= UI ================= */
  return (
    <>
      <div className="login-page-container">
        {/* Background */}
        <div className="login-bg"></div>
        <div className="login-bg login-bg2"></div>
        <div className="login-bg login-bg3"></div>

        {/* CARD */}
        <div className={`login-card ${isSwapped ? "swap-active" : ""}`}>
          {/* LEFT */}
          <div className="login-left-section">
            {company.logo ? (
              <img
                src={getImageUrl(company.logo)}
                alt="Company Logo"
              />
            ) : (
              <img
                src="https://static.vecteezy.com/system/resources/thumbnails/003/689/228/small/online-registration-or-sign-up-login-for-account-on-smartphone-app-user-interface-with-secure-password-mobile-application-for-ui-web-banner-access-cartoon-people-illustration-vector.jpg"
                alt="illustration"
              />
            )}
          </div>

          {/* RIGHT */}
          <div className="login-right-section">
            <div className="login-right-section-company-name">
              {company.name || "Company Name"}
            </div>

            <h2 className="login-right-section-title">Welcome Back :)</h2>

            <p className="login-right-section-subtitle">
              {/* Login using your credentials <Lock size={18} /> */}
              To keep connected with us please login with your personal information by email address and password{" "} <Lock size={20} color="#3498db" />
            </p>

            {fetchError && (
              <div className="login-error-div">{fetchError}</div>
            )}
            {error && (
              <div className="login-error-div">{error}</div>
            )}
            {frontError && (
              <div className="login-error-div">{frontError}</div>
            )}

            {/* FORM */}
            <form onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div className="login-form-input-group">
                <input
                  type="email"
                  placeholder="Email Address"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  required
                />
                <span className="login-form-input-icon">
                  <Mail size={20} color="#535252" />
                </span>
              </div>

              {/* PASSWORD */}
              <div className="login-form-input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="login-form-input-icon clickable"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOffIcon size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </span>
              </div>

              {/* BUTTON */}
              <button
                disabled={loading || frontLoading}
                className="login-form-submit-btn"
              >
                {frontLoading ? "Please wait..." : "Login Now"}
              </button>
            </form>
          </div>

           <div className="login-toggle-center">
    <button onClick={() => setIsSwapped(!isSwapped)}>
      <ArrowLeftRight size={22} className={isSwapped ? "rotated" : ""} />
    </button>
  </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="login-page-footer-section">
        <div className="login-page-footer-left">
          <p>
            © {new Date().getFullYear()}{" "}
            {company.name || "Techvision Demo Software"}.
          </p>
        </div>
        <div className="login-page-footer-right">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms</a>
          <a href="/support">Support</a>
        </div>
      </footer>

      {/* LOADER */}
      {frontLoading && (
        <div className="login-ripple-loader-overlay">
          <div className="login-ripple-loader">
            <div className="login-ripple-circle"></div>
            <div className="login-ripple-circle delay"></div>

            <img
              src={
                company.logo
                  ? getImageUrl(company.logo)
                  : "https://via.placeholder.com/100"
              }
              alt="logo"
              className="login-ripple-logo"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default LoginPage;